import { useIntl } from "react-intl";
import { Center } from "../components/Center";

export default function MainDashboard() {
  const intl = useIntl();
  const welcome = intl.formatMessage({ id: "welcome" });
  return (
    <Center>
      <h1>{welcome}</h1>
    </Center>
  );
}
